import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { auth } from 'firebase'
import styled from 'styled-components'

const CenterDiv = styled.div`
  text-align: center;
`
const ProfileCircle = styled.div`
  height: 50px;
  width: 50px;
  background: black;
  border-radius: 50%;
`
const UserImage = styled.img`
  width: 70px;
  border-radius: 50%;
`
class SignedInLinks extends Component {
  render() {
    const profileImage = auth().currentUser.photoURL ? 
      <UserImage src={auth().currentUser.photoURL} alt="user"></UserImage> 
      : <ProfileCircle></ProfileCircle>
    return (
      <CenterDiv>
        <Link to="/profile">
          {profileImage}
        </Link>
      </CenterDiv>
    )
  }
}

export default SignedInLinks



// WEBPACK FOOTER //
// ./src/components/navbar/SignedInLinks.js